/**
 * @typedef IssuedTokenData
 * @property {string} access_token
 * @property {number} expires_in Amount of time in seconds until the access token expires
 * @property {'Bearer'} token_type
 */
